
export const phoneTypeOptions = [
	{ value: 'office', label: 'Office' },
	{ value: 'mobile', label: 'Mobile' },
	{ value: 'home', label: 'Home' },
];